import { render, staticRenderFns } from "./AdListGrid.vue?vue&type=template&id=50988b12&scoped=true&"
import script from "./AdListGrid.vue?vue&type=script&lang=js&"
export * from "./AdListGrid.vue?vue&type=script&lang=js&"
import style0 from "./AdListGrid.vue?vue&type=style&index=0&id=50988b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50988b12",
  null
  
)

export default component.exports